'use client';

import { useEffect, useContext } from 'react';
import GoogleAnalytics from '@bradgarropy/next-google-analytics';
import { ThemeContext, ThemeProvider } from 'utils/ThemeContext';
import ScrollTop from 'components/scroll-top.js';
import { GoogleTagManager } from '@next/third-parties/google';

import Layout from 'components/Layout/Layout';

import 'styles/globals.scss';
import 'html/cylerian.scss';
import 'html/responsive.scss';
import 'components/Services/SummarySection/SummarySection.scss';
import 'components/Services/StatsBar/StatsBar.scss';
import 'components/Services/ProcessSteps/ProcessSteps.scss';
import 'components/Services/CoverageGrid/CoverageGrid.scss';

const NEXT_PUBLIC_GOOGLE_ANALYTICS_ID = 'G-FSGVKDZQ1R';

const GOOGLE_TAG_MANAGER_ID = 'GTM-P22FJFVF';

const Root = ({ children }) => {
	const { theme, themeChange } = useContext(ThemeContext);

	if (!theme) {
		return (
			<html lang='en'>
				<body>{children}</body>
			</html>
		);
	}

	return (
		<html lang='en' className={theme}>
			<body>{children}</body>
		</html>
	);
};

const MyApp = props => {
  const {children, params} = props;

  return <ThemeProvider>
    <Root>
      <Layout>
		<GoogleTagManager gtmId={GOOGLE_TAG_MANAGER_ID} />
        <GoogleAnalytics measurementId={NEXT_PUBLIC_GOOGLE_ANALYTICS_ID}/>
        <ScrollTop />
        {children}
      </Layout>
    </Root>
  </ThemeProvider>;
};

export default MyApp;
